/* ------------------------ Functional imports start ------------------------ */
import { useRef } from 'react'
/* ------------------------- Functional imports end ------------------------- */

export type UniqueKeyGenerator = {
  get: () => string
  reset: () => void
}

/* -------------------------------------------------------------------------- */
/*                                 Start Hook                                 */
/* -------------------------------------------------------------------------- */
export default function useUniqueKey(prefix = '', suffix = ''): UniqueKeyGenerator {
  const counter = useRef(0)

  /**
   * Returns a unique key based on an auto incrementing counter and the specified
   * prefix and suffix.
   * @returns
   */
  function get(): string {
    counter.current += 1
    return `${!!prefix ? prefix + '-' : ''}${counter.current}${!!suffix ? '-' + suffix : ''}`
  }

  /**
   * Resets the
   */
  function reset(): void {
    counter.current = 0
  }
  return { get, reset }
}
